export default function CElseIf() {
  return <h2>C Else If</h2>;
}
